export default __webpack_public_path__ + "static/media/Reader's Belt of the Moon.caa5e5aa.jpg";